import React from 'react'
import Draggable from "../../../DnD/Draggable";
import InputWrapper from "../../../../../components/Input/InputWrapper";

function Select() {
    return (
        <Draggable id="input-select">
            <InputWrapper>
                Select
                <div className="select"/>
            </InputWrapper>
        </Draggable>
    )
}

export default Select
